import React from 'react';
import { useIntl } from 'react-intl-next';

import { fg } from '@atlaskit/platform-feature-flags';

import { AdvancedSearchFooter, type AdvancedSearchFooterProps } from '../../advanced-search-footer/advanced-search-footer';
import { messages } from '../messages';
import { QuickFindAdvancedSearchLink } from './quick-find-footer.styled';
import { PersistRecentSearch } from '../../recent-searches/persist-recent-search';

export const SearchFooter: ({ linkComponent }: AdvancedSearchFooterProps) => React.JSX.Element = ({ linkComponent }: AdvancedSearchFooterProps) => {
	const { formatMessage } = useIntl();
	return (
		<QuickFindAdvancedSearchLink>
			<AdvancedSearchFooter
				linkComponent={linkComponent}
				squareReturnIcon
				searchFooterLabel={formatMessage(
					fg('product-terminology-refresh')
						? messages.quick_find_footer_full_page_search_link_appify
						: messages.quick_find_footer_full_page_search_link,
				)}
			/>
		</QuickFindAdvancedSearchLink>
	);
};

// wraps the search footer with persistRecentSearch
export const SearchFooterPersistRecentSearch: ({ linkComponent }: AdvancedSearchFooterProps) => React.JSX.Element = ({ linkComponent }: AdvancedSearchFooterProps) => {
	return (
		<PersistRecentSearch>
			<SearchFooter linkComponent={linkComponent} />
		</PersistRecentSearch>
	);
};
